import React, { useState } from "react";
import classes from "../../module.css/RealTimeStockOne.module.css";
import Heading from "../../tailwindUI/Heading";
import Filter from "../../tailwindUI/Filter";
import Card from "../../tailwindUI/Card";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "../../tailwindUI/Navbar";
import StatsCard from "../../tailwindUI/StatsCard";

const AsmDashboard = () => {
  const [loading, setLoading] = useState(false);
  const UserToken = localStorage.getItem("UserToken");
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    dataCount();
  }, []);
  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };


  const dataCount = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${global.apiBaseUrl}/api/v1/stockone/srm/StockCount`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success" && result.status_code === 200) {
          setData(result);
        }
      })
      .catch((error) => console.log("error", error))
      .finally(() => setLoading(""));
  };

  const BreadCrumb = {
    pagename: "TL/ASM Dashboard",
    pagePath: "/asm-dashboard",
  };


  const stats = [
    {
      name: "Total Active Bookings",
      Count: data.currentmonthallocated +
      data.currentmonthawaited +
      data.currentmonthautocancelled,
      icon: "./assets/logos/today.png",
    },

    {
      name: "Allocated",
      Count: data.currentmonthallocated ? data.currentmonthallocated : 0,
      icon: "./assets/logos/deliveredreq.png",
    },
    {
      name: "Allocation Awaited",
      Count: data.currentmonthawaited
        ? data.currentmonthawaited
        : 0,
      icon: "./assets/logos/request.png",
    },

    {
      name: `Auto Allocation Cancelled`,
      Count: data.currentmonthautocancelled ? data.currentmonthautocancelled : 0,
      icon: "./assets/logos/delivered.png",
    },
    {
      name: `Bookings Cancelled`,
      Count: data.currentmonthcancelled ? data.currentmonthcancelled : 0,
      icon: "./assets/logos/currentmonth.png",
    },
    {
      name: `Current Month Bookings`,
      Count: data.currentmonthbooking ? data.currentmonthbooking : 0,
      icon: "./assets/logos/currentmonth.png",
    },
    {
      name: `Delivered This Month`,
      Count: data.deliverytilldate ? data.deliverytilldate : 0,
      icon: "./assets/logos/currentmonth.png",
    },
    {
      name: `Counter Finance Penetration`,
      Count: data.FinancePenetrationPercentage ? data.FinancePenetrationPercentage : 0,
      icon: "./assets/logos/counter.png",
    },
    {
      name: `Exchange Penetration`,
      Count: data.ExchangePenetrationPercentage ? data.ExchangePenetrationPercentage : 0,
      icon: "./assets/logos/exchange.png",
    },
  ];
  
  const mothdata=[
    {
      name: `Counter Finance Penetration Current Month`,
      Count: data.CurrentMonthFinancePenetrationPercentage ? data.CurrentMonthFinancePenetrationPercentage : 0,
      icon: "./assets/logos/counter.png",
    },
    {
      name: `Exchange Penetration Current Month`,
      Count: data.CurrentMonthExchangePenetrationPercentage ? data.CurrentMonthExchangePenetrationPercentage : 0,
      icon: "./assets/logos/exchange.png",
    },
  ]
  const prevmothdata=[
    {
      name: `Counter Finance Penetration Previous Month`,
      Count: data.LastMonthFinancePenetrationPercentage ? data.LastMonthFinancePenetrationPercentage : 0,
      icon: "./assets/logos/counter.png",
    },
    {
      name: `Exchange Penetration Previous Month`,
      Count: data.LastMonthExchangePenetrationPercentage ? data.LastMonthExchangePenetrationPercentage : 0,
      icon: "./assets/logos/exchange.png",
    },
  ]

  return (
    <>
      <Navbar navbarType="asm navbar" />
      <Heading
        headingType={"Page Headings"}
        headingText={"Dashboard"}
        subheadingText={localStorage.getItem("Location")}
        BreadCrumb={BreadCrumb}
      />

      {loading ? (
        <div className={classes.loader}>
          {" "}
          <img src="assets/loadingGif.gif" alt="loading" />
        </div>
      ) : (
        <div className="m-16 ">
          <div className="">
            <div className="">
              <h1 className="font-bold text-lg  mb-2">Overall Data</h1>
              <StatsCard data={stats} type="ASM" />
            </div>
            <div className="my-8">
              <h1 className="font-bold text-lg  mb-2">Current Month Data</h1>
              <StatsCard data={mothdata} type="ASM" rep="per" />
            </div>
            <div className="">
              <h1 className="font-bold text-lg  mb-2">Previous Month Data</h1>
              <StatsCard data={prevmothdata} type="ASM" rep="per" />
            </div>
            
          </div>
        </div>
      )}
    </>
  );
};

export default AsmDashboard;
